import React from 'react';
import { GCPActionType, GcpVmAction, GCPResourceType } from './types';
import { ActionConfirmationDisplay } from '../../types';
import { ActionConfirmationDialog } from '../../ActionConfirmationDialog';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  action: GCPActionType;
  isLoading: boolean;
  service: GCPResourceType;
}

interface DialogConfig {
  title: string;
  content: string;
  actionDisplay: ActionConfirmationDisplay;
}

const getDialogConfig = (
  action: GCPActionType,
  service: GCPResourceType,
): DialogConfig => {
  switch (service) {
    case 'vm': {
      const actionDisplays: Record<GcpVmAction, ActionConfirmationDisplay> = {
        start: { text: 'Start', color: 'primary' },
        stop: { text: 'Stop', color: 'secondary' },
        restart: { text: 'Restart', color: 'primary' },
      };
      const actionDisplay = actionDisplays[action as GcpVmAction];
      const title = `Confirm ${actionDisplay.text} GCP VMs`;
      const content = `Are you sure you want to ${actionDisplay.text.toLowerCase()} GCP VMs?`;
      return { title, content, actionDisplay };
    }
    default: {
      return {
        title: 'Confirm',
        content: `Are you sure you want to execute ${action} action?`,
        actionDisplay: { text: action, color: 'primary' },
      };
    }
  }
};

export const GcpActionConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  action,
  isLoading,
  service,
}) => {
  if (!action) {
    return null;
  }

  const { title, content, actionDisplay } = getDialogConfig(action, service);

  return (
    <ActionConfirmationDialog<GCPActionType>
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      action={action}
      isLoading={isLoading}
      actionDisplay={actionDisplay}
      title={title}
      content={content}
    />
  );
};
